import { ModalParams } from 'src/components/Modals/types';
import {
	NavigationOption,
	NavigationCase,
	RouteNavigationResult,
	WindowNavigationResult,
	ModalNavigationResult,
	DesktopNavigationOption,
} from 'src/components/Navigation/types';

export const makeRouteResult = (
	route: string,
	opts?: RouteNavigationResult['opts']
): RouteNavigationResult => ({
	type: NavigationCase.NAVIGATE_TO_ROUTE,
	route,
	opts,
});

export const makeModalResult = (modal: ModalParams): ModalNavigationResult => ({
	type: NavigationCase.OPEN_MODAL,
	modal,
});

export const makeWindowResult = (href: string): WindowNavigationResult => ({
	type: NavigationCase.OPEN_WINDOW,
	href,
});

export const filterByHideCondition = (
	navOption: NavigationOption | DesktopNavigationOption
) => !navOption.hideCondition;
